import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import NavHeader from "./components/NavHeader";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Account from "./pages/Account";
import Transactions from "./pages/Transactions";
import RIghtSidebar from "./components/RIghtSidebar";
import Staking from "./pages/Staking";
import NotFound from "./pages/NotFound";
import CoinDetail from "./pages/CoinDetail";
import FindX from "./pages/FindX";
import { SidebarProvider } from "./context/useSidebar";

const LayoutAndRoutes = () => {
  return (
    <div id="main-wrapper" className={`wallet-open active`}>
      <ToastContainer />
      <NavHeader />
      <Header />
      <Sidebar />
      <RIghtSidebar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/account" element={<Account />} />
        <Route exact path="/new" element={<CoinDetail />} />
        <Route exact path="/transactions" element={<Transactions />} />
        {/* <Route exact path="/staking" element={<Staking />} /> */}
        <Route exact path="/bunswap" element={<FindX />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <SidebarProvider>
          <LayoutAndRoutes />
        </SidebarProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
